module.exports = __webpack_public_path__ + "media/images/personnel/Anna_H-df0da5b1404e181dff8fd597b77f7c5d.png";